import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageTitle } from "../components/common";
import { PRICING_BASES, SERVICE_TYPES } from "../lib/labels";

const num = (v) => `${String(v).replace(".", ",")} €`;

function summary(t) {
  const parts = [];
  if (t.forfait != null) parts.push(`Forfait ${num(t.forfait)}`);
  if (t.ups_percent != null) parts.push(`${t.ups_percent} % du montant UPS`);
  Object.entries(t.unit_prices || {}).forEach(([k, v]) => parts.push(`${num(v)} / ${(PRICING_BASES[k] || k).toLowerCase()}`));
  (t.tiers || []).filter((x) => x.min).forEach((x) => parts.push(`${x.min}–${x.max || "+"} : ${num(x.price)}`));
  return parts.join(" · ") || t.display || "À confirmer";
}

export default function MyTariffs() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/tariffs").then((r) => setRows(r.data));
  }, []);
  return (
    <div>
      <PageTitle title="Mes tarifs" sub="Tarifs sous-traitant appliqués à vos prestations (lecture seule)." />
      <div className="tl-card overflow-x-auto">
        <table className="tl-table" data-testid="my-tariffs-table">
          <thead><tr><th>Service</th><th>Tarif</th><th>Zone / jour</th><th>Montant</th></tr></thead>
          <tbody>
            {rows.map((t) => (
              <tr key={t.id} data-testid={`my-tariff-${t.id}`}>
                <td>{SERVICE_TYPES[t.service_type]}</td>
                <td>{t.label}</td>
                <td className="text-xs">{[t.zone, t.day_type !== "tous" && t.day_type].filter(Boolean).join(" · ") || "—"}</td>
                <td className="tl-mono text-sm">{summary(t)}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={4} className="text-slate-500">Aucun tarif.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
